export const CustomerRefundsHeader = [
  'Product Code',
  'Product Description',
  'Pet Name',
  'Price Paid (after discount)',
  'Already Refunded',
  'Available for Refund',
  'Amount to Refund',
  'Total Refund Including Tax',
];

export const ShippingRefundsHeader = [
  'Shipping',
  'Price Paid',
  'Already Refunded',
  'Available for Refund',
  'Amount to Refund',
  'Total Refund Including Tax',
];

export const SplitFulfillmentHeaders = [
  'Fulfillment ID',
  'Pet Name',
  'Product Code',
  'Product Description',
  'Quantity',
];

export const ReplacementOrderHeader = [
  'Pet Name',
  'Quantity',
  'Product Code',
  'Product Description',
];

export const ProductsTableHeader = [
  'Pet Name',
  'Product Code',
  'Product Description',
  'Total Items',
  'Price',
  'Price with Tax',
];

export const FulfillmentHeader = [
  'Fulfillment ID',
  'Fulfillment Center',
  'Fulfillment Status',
  'Tracking #s',
  'Pet',
  'Product Code',
  'Product Description',
  'Total Items',
  'Price',
  'Price with Tax',
  'Claims',
];

export const CustomerOrdersHeader = [
  'Order ID',
  'Order Status',
  'Order Date',
  'Order Type',
  'Order Total',
  'Pet(s)',
  'Payment Status',
  'Shipping Address',
];

export const CustomerPlansHeader = [
  'Pet Status',
  'Pet Name',
  'Pet Gender',
  'Pet ID',
  'Product Code',
  'Frequency',
  'Product Description',
  'Topper Plan',
  'Cost',
  'Next Order',
];

export const CustomerSearchHeaders = [
  'Name',
  'Email',
  'Pet Names',
  'Status',
  'Account Created',
  'Last Updated',
  'Primary Shipping Address',
];

export const UnKibbleProductInfoHeaders = [
  'Code',
  'Description',
  'Type',
  'Recurring',
  'Frequency',
  'Plan Size',
  'Status',
  'PACKOUT DEFINITION',
  'Price (per DAY)',
  'Price (per WEEK)',
  'Price (per SHIPMENT)',
  'FILL AMOUNT # (per bag)',
  'CALORIES (per bag)',
  '# of BAGS (per shipment)',
  'SCOOP SKU #',
  'CALORIES (per scoop)',
  'SCOOP VOLUME (ml)',
  'US Cup Equivalent per Scoop',
  '# of SCOOPS (per day)',
  'BAG WEIGHT (oz)',
];

export const FreshProductInfoHeaders = [
  'Code',
  'Description',
  'Type',
  'Recurring',
  'Frequency',
  'Plan Size',
  'Status',
  'PACKOUT DEFINITION',
  'Price (per DAY)',
  'Price (per WEEK)',
  'Price (per SHIPMENT)',
  'OZ (per pack)',
  'CALORIES (per pack)',
  '# of PACKS (per shipment)',
  '# of PACKS (fed per day)',
  '# of PACKS (fed per meal)',
];

export const AncillaryProductInfoHeaders = [
  'Code',
  'Description',
  'Type',
  'Recurring',
  'Status',
  'Price (per Product Code)',
  'Product contents',
];

export const NutrientAnalysisHeaders = [
  '',
  ' ', // Need this space to help identify data to header
  'As Fed Basis\n(indicates presence of nutrient as it is received)',
  'Dry Matter Basis\n(indicates presence of nutrient when all moisture is removed)',
];

export const UserManagementHeaders = [
  'Name',
  'Email',
  'User Group',
  'Added',
  'Last Updated',
  'Status',
];

export const DiscountsHeader = [
  'Discount Code',
  'Discount Type',
  'Value',
  'Created date',
  'Start date',
  'End date',
  'Limit type',
  'Limit value',
  'Order Types',
  'Status',
  'Eligible Country',
];

export const PromotionsHeader = [
  'Promotion',
  'Promotion Surface',
  'Status',
  'Start date',
  'End date',
  'Free Product',
  'Eligible Country',
];

export const ItemsHeader = ['Item SKU', 'Name', 'Weight (oz)', 'Volume', 'Recipe ID'];

export const ProductItemsHeader = ['Product Code', 'Product Name', 'Product Status', 'Items'];

export const FinancialHeaders = [
  'Price',
  'Price with Tax',
  'Order Total',
  'Cost',
  'Price Paid (after discount)',
  'Already Refunded',
  'Available for Refund',
  'Amount to Refund',
  'Total Refund Including Tax',
];
